import styled, { css } from 'styled-components';

import { xdlPalettePetrol03, xdlPalettePetrol04 } from '@xing-com/tokens';

export const ItemButton = styled.button.attrs({
  role: 'menuitem',
  tabIndex: 0,
})<{
  $selected: boolean;
}>`
  cursor: pointer;
  font-size: 1.6em;
  height: 33px;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 300px;

  ${({ $selected }) =>
    $selected &&
    css`
      color: ${xdlPalettePetrol04} !important;
    `}

  &:hover,
  &:focus {
    color: ${xdlPalettePetrol03};
  }
`;
